const firebaseConfig = {
    apiKey: "AIzaSyBA-yvzK4_1_GLwJWQ2mRkSaGxvcqMuqU8",
    authDomain: "dev-book-shop.firebaseapp.com",
    projectId: "dev-book-shop",
    storageBucket: "dev-book-shop.appspot.com",
    messagingSenderId: "630975753326",
    appId: "1:630975753326:web:50184bf3d5f17d60b70a7f"
  };
    export default firebaseConfig;